import CRUDTableComponent from '../../components/CRUDTableComponent'

const SurgeriesTable = () => {
  const tableColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      type: 'string',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
  ]

  return (
    <CRUDTableComponent
      entityName={{ singular: 'Cirugía', plural: 'Cirugías' }}
      tableColumns={tableColumns}
      entityUrl="/surgeries?sortBy=name"
    />
  )
}

export default SurgeriesTable
